import { Toaster } from 'sonner';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import '@/styles/index.css';

import { SuspenseFallbackUI } from './components/ui/Loader.tsx';
import { RoutesPage } from './components/lib/ReactRouterWrapper.tsx';
import { ReactQueryWrapper } from './components/lib/ReactQueryWrapper.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ReactQueryWrapper>
      <Suspense fallback={<SuspenseFallbackUI />}>
        <Toaster richColors />
        <RoutesPage />
      </Suspense>
    </ReactQueryWrapper>
  </StrictMode>,
);
